import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=0168f3ee&scoped=true&"
import script from "./DesktopMenu.vue?vue&type=script&lang=ts&"
export * from "./DesktopMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopMenu.vue?vue&type=style&index=0&id=0168f3ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0168f3ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
